// The Tooltip body for an At Risk / Breached figure — one "Vehicle not booked: 21" line per
// reason, biggest bucket first. Reasons come from the summary endpoint's at_risk_reasons /
// breach_reasons maps (sent both board-wide and per lane, zero buckets included — those are
// dropped here). Returns null when every bucket is zero or the map is absent, which suppresses
// the tooltip entirely (antd shows no tooltip for an empty title).
import React from "react";

// "vehicle_not_booked" → "Vehicle not booked". The backend keys are stable snake_case slugs.
const humanize = (key: string): string => {
  const spaced = key.replace(/_/g, " ");
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
};

export const reasonBreakdown = (
  reasons?: Record<string, number> | null
): React.ReactNode => {
  const entries = Object.entries(reasons ?? {}).filter(([, count]) => count > 0);
  if (entries.length === 0) return null;
  entries.sort((a, b) => b[1] - a[1]);
  return (
    <div>
      {entries.map(([reason, count]) => (
        <div key={reason}>
          {humanize(reason)}: {count}
        </div>
      ))}
    </div>
  );
};
